import React, { useState, useEffect } from 'react';
import { fetchRebatesDeLiquidacionApi } from "../../../../api/axios";
import { formatoDecimal } from "../../../../utilities/formatoNumeros"
import BigSpinner from "../../../General/BigSpinner";
import { toast } from "react-toastify";

export default function RebatesDeLiquidacion({ idLiquidacion }) {
  const [isFetching, setIsFetching] = useState(true);
  const [rebates, setRebates] = useState([]);

  useEffect(() => {
    let response = fetchRebatesDeLiquidacionApi({ idLiquidacion: idLiquidacion });

    response.then(res => {
      setRebates(res.data.rebates)
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.warn(error))
        : toast.error("No pudieron ser obtenidos los rebates de la liquidacion");
    }).finally(() => {
      setIsFetching(false);
    });
  }, []);


  return (
    <div className="row justify-content-center align-items-center p-10">
      <h5 className="col-auto" hidden={rebates.length === 0}>Rebates</h5>
      <div className="card">
        {isFetching ? <BigSpinner /> :
          <div className="row list-group-item">
            {rebates && rebates.length > 0 ?
              <div className="table-responsive p-0">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Id Rebate</th>
                      <th>Id Venta</th>
                      <th>Precio Original</th>
                      <th>Precio Publicado</th>
                      <th>Rebate Megatone</th>
                      <th>Rebate Seller</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rebates.map((rebate, index) => {
                      return (
                        <tr key={index} className="hover-background-color">
                          <td><small>{rebate.idRebate}</small></td>
                          <td><small>{rebate.idVenta}</small></td>
                          <td><small>${formatoDecimal(rebate.precioOriginal)}</small></td>
                          <td><small>${formatoDecimal(rebate.precioPublicado)}</small></td>
                          <td><small>${formatoDecimal(rebate.rebateMegatone)}</small></td>
                          <td><small>${formatoDecimal(rebate.rebateSeller)}</small></td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              :
              <div className="d-flex justify-content-center m-t-40 m-b-40">
                No se encontraron rebates para esta liquidación
              </div>
            }
          </div>
        }
      </div>
    </div>
  )
}